module.exports = __webpack_public_path__ + "a2bb70409e0310c8a5e8bcb8947feea6.fbx";